import MapMenu from '../lib/map_menu';
import UiInteraction from '../lib/ui_interaction';
import Feature from '../lib/feature';
import createMarkerPin, {
	panIntoViewOnFocus,
	sortBySoutheastProximity,
	coincidentMarkerCoords,
} from '../lib/marker_pin';

export default class InfolabsLayer {
	constructor() {
		this.checkboxEl = document.getElementById('infolabs-layer');
		this.visible = false;
		this.markers = [];
	}

	add() {
		this.getData().then(() => {
			sortBySoutheastProximity(this.features, (feature) => feature.properties.map_object_id);
			const displayCoords = coincidentMarkerCoords(this.features);

			this.features.forEach((feature) => {
				const markerEl = createMarkerPin('marker-layer-infolab', '#F68709', feature.properties.name);
				const coordinates = displayCoords.get(feature) || feature.geometry.coordinates;
				panIntoViewOnFocus(markerEl, coordinates);

				const marker = new mapboxgl.Marker(markerEl, { anchor: 'bottom' })
					.setLngLat(coordinates)
					.addTo(W.map);

				markerEl.addEventListener('click', (e) => {
					this.openPopup(feature, e, markerEl);
				});

				this.markers.push(marker);
			});

			this.visible = true;
			this.panIfNeeded();
			MapMenu.hide();
		});
	}

	remove() {
		this.markers.forEach((marker) => marker.remove());
		this.markers = [];
		UiInteraction.clearAllPopups();
		this.visible = false;
	}

	openPopup(feature, e, markerEl) {
		UiInteraction.clearAllPopups();
		const featureObj = Feature.factory(feature.properties);
		UiInteraction.fetchAndAddFeature(featureObj, { marker: markerEl });
		e.stopPropagation();
	}

	async getData() {
		if (this.features) return;

		const url = W.api_root + 'infolabs/locations';
		try {
			const response = await fetch(url);
			if (!response.ok) {
				throw new Error(`Response status: ${response.status}`);
			}
			const json = await response.json();
			this.features = json.features;
		} catch (error) {
			console.error(error.message);
		}
	}

	panIfNeeded() {
		if (!this.features || this.features.length === 0) return;

		const mapBounds = W.map.getBounds();
		const anyVisible = this.features.some((feature) =>
			mapBounds.contains(feature.geometry.coordinates),
		);

		if (!anyVisible) {
			const bounds = this.features.reduce((bounds, feature) => {
				return bounds.extend(feature.geometry.coordinates);
			}, new mapboxgl.LngLatBounds());

			W.map.fitBounds(bounds, {
				maxZoom: 14,
				padding: 30,
			});
		}
	}
}
